<template>
  <div>
    <form v-on:submit.prevent="submitSearch">
      <div class="input-group input-group--search">
        <label for="input-search" class="input-group relative">
          <div class="icon bg-white">
            <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.5421 17.6747H19.2901L18.8463 17.2468C20.3994 15.4401 21.3344 13.0947 21.3344 10.5432C21.3344 4.85387 16.7228 0.242188 11.0334 0.242188C5.3441 0.242188 0.732422 4.85387 0.732422 10.5432C0.732422 16.2325 5.3441 20.8442 11.0334 20.8442C13.5849 20.8442 15.9304 19.9092 17.737 18.3561L18.1649 18.7998V20.0518L26.0887 27.9598L28.4501 25.5985L20.5421 17.6747ZM11.0334 17.6747C7.08735 17.6747 3.90196 14.4893 3.90196 10.5432C3.90196 6.59712 7.08735 3.41173 11.0334 3.41173C14.9795 3.41173 18.1649 6.59712 18.1649 10.5432C18.1649 14.4893 14.9795 17.6747 11.0334 17.6747Z" fill="#3E3EFF"/>
            </svg>
          </div>
          <input
            type="text"
            class="input"
            id="input-search"
            :placeholder="'Type your question here...'"
            v-model="query"
            v-on:blur="inputBlur"
            v-on:input="queryChange"
            autocomplete="off"
          >
        </label>
        <div
          class="pl0 autocomplete-results absolute w-100"
          @mouseover="isHovering"
          @mouseleave="notHovering"
          v-show="isOpen"
        >
          <p class="ma0 suggestion-title pa3">{{$t('topArticlesTextZen')}}</p>
          <ul class="ma0 pa0">
            <router-link
              v-for="(result, i) in results"
              :key="i"
              class="no-underline"
              :to="{name: 'article', hash: getHash(result)}"
              v-on:click.native="closeSuggestions"
            >
              <li class="autocomplete-result f6 flex flex-row w100 ph3">
                <p class="ma0 autocomplete-result-title flex1">
                  <span class="pl1" v-html="result.htmlTitle"></span>
                  <span class="mv0 autocomplete-result-category">-</span>
                  <span class="mv0 mr2 autocomplete-result-category">{{result.category}}</span>
                </p>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  getLanguage,
  getPageHash,
  searchLocalArticles,
  formatArticleTitles,
  getCategoryIdByArticleId,
  getCategoryById
} from '@/utils/common';
export default {
  data: () => {
    return {
      query: '',
      articles: [],
      results: [],
      isOpen: false,
      hovering: false
    };
  },
  created: function() {
    const matches = this.$route.hash.match(new RegExp('query' + '=([^&]*)'));
    this.query = matches ? decodeURIComponent(matches[1]).replace(/\+/g, ' ') : null;
  },
  methods: {
    getHash(article) {
      return getPageHash(article);
    },
    submitSearch() {
      const lng = getLanguage();
      const urlQuery = this.query ? this.query.replace(/ /g, '+') : '';
      this.closeSuggestions();
      const newUrl = `/${lng}/search#query=${urlQuery}`;
      this.$router.push(newUrl);
      if (window.location.href.includes('search')) {
        this.$router.go(0);
      }
    },
    queryChange() {
      if (this.query === '') {
        this.isOpen = false;
        return;
      }
      this.filterResults();
    },
    filterResults() {
      const queries = this.query.split(' ').map(query => new RegExp(`(${query})`, 'i'));
      this.articles = searchLocalArticles(queries);
      const articles = formatArticleTitles(this.articles, this.query);
      const suggestions = articles.map(article => {
        const catId = getCategoryIdByArticleId(article.id);
        const { title } = getCategoryById(catId);
        return { ...article, category: title };
      });
      if (suggestions.length === 0) {
        this.results = [];
        this.isOpen = false;
        return;
      }
      this.isOpen = true;
      this.results = suggestions.slice(0, 6);
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpen = false;
      }
    },
    closeSuggestions() {
      this.isOpen = false;
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group--search {
  text-align: left;
  display: block;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 100%;
  width: 100%;
  position: relative;
  .input {
    border: 2px solid #3E3EFF;
    border-radius: 10px;
    font-size: 18px;
    font-family: 'Open Sans', sans-serif;
    height: 60px;
    width: 100%;
    font-weight: 400;
    color: #A7ACC6;
    background: #fff;
    outline: none;
    padding: 10px 54px;
    &::placeholder {
      color: #A7ACC6;
      opacity: 1;
    }
  }
  .icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
  }
  &:focus {
    outline: none;
    border: none;
  }
}
.suggestion-title {
  border-bottom: 1px solid #f3f3f3;
}
//Results styles
.autocomplete-results {
  margin: 0;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  overflow: auto;
  background-color: #fff;
  top: 5.8rem;
}
.autocomplete-result {
  list-style: none;
  text-align: left;
  cursor: pointer;
  color: #555;
  padding-top: 8px;
  padding-bottom: 8px;
}
.autocomplete-result-title {
  overflow: hidden;
  text-overflow: ellipsis;
  //   height: 24px;
  white-space: nowrap;
}
.autocomplete-result:hover {
  background-color: #f4f4f4;
}
.autocomplete-result-category {
  color: #ccc;
  font-size: 80%;
  line-height: 19.6875px;
}
@media (min-width: 480px) {
  .input-group--search {
    max-width: 60%;
    padding: 0;
  }
}
@media (min-width: 992px) {
  .input-group--search {
    max-width: 36%;
  }
}
</style>
